import { render, staticRenderFns } from "./FollowUPLogs.vue?vue&type=template&id=33b9c9e8&scoped=true"
import script from "./FollowUPLogs.vue?vue&type=script&lang=js"
export * from "./FollowUPLogs.vue?vue&type=script&lang=js"
import style0 from "./FollowUPLogs.vue?vue&type=style&index=0&id=33b9c9e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b9c9e8",
  null
  
)

export default component.exports